import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdLock, MdPerson
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import Profile from 'views/admin/profile';
import Vehicules from 'views/admin/vehicules';
import VehicleDetails from 'views/admin/vehicules/details';
import Utilisateurs from 'views/admin/utilisateurs';
import Patients from 'views/admin/patients';
import Missions from 'views/admin/missions';
import DossierRegulation from 'views/admin/dossier-regulation';
import DossierRegulationCreate from 'views/admin/dossier-regulation/creat';
import DossierRegulationDetails from 'views/admin/dossier-regulation/details';
import DossierRegulationEdit from 'views/admin/dossier-regulation/edit';
import DossierRegulationDecision from 'views/admin/dossier-regulation/decision';
import MissionDetails from 'views/admin/missions/details';
import MissionCreate from 'views/admin/missions/creat';
import MissionUpdate from 'views/admin/missions/edit';
import GpsMap from 'views/admin/gps-map';
import Materiels from 'views/admin/materiels';
import PrestationMap from 'views/prestation';
import Avis from 'views/admin/avis';
import PermissionWrapper from 'components/PermissionWrapper';
import Reclamations from 'views/admin/reclamations';
import Analyses from 'views/admin/analyses';
import Logs from 'views/admin/logs';
import PointageSuivi from 'views/admin/pointage-suivi';
import GestionStock from 'views/admin/gestion-stock';
import Documentation from 'views/admin/documentation';

import ForgotPassword from 'views/auth/forgotPassword';
// Auth Imports
import SignInCentered from 'views/auth/signIn';
import { FaMoneyBillAlt } from 'react-icons/fa';

const routes = [

  {
    category: true,
    name: 'Gestion de mission',
    items: [
      {
        name: 'Tableau de bord',
        layout: '/admin',
        path: '/default',
        icon: 'tableaudebord.png',
        component: <MainDashboard />,
        requiredPermission: 'dashboard_view',
      },
      {
        name: 'Dossier de régulation',
        layout: '/admin',
        path: '/dossier-regulation',
        icon: 'missions.png',
        component: <DossierRegulation />,
        requiredPermission: 'missions_view',
      },
      {
        name: 'Créer dossier de régulation',
        layout: '/admin',
        path: '/dossier-regulation/create',
        icon: 'missions.png',
        component: <DossierRegulationCreate />,
        requiredPermission: 'missions_view',
        hidden: true,
      },
      {
        name: 'Détails dossier de régulation',
        layout: '/admin',
        path: '/dossier-regulation/:id',
        icon: 'missions.png',
        component: <DossierRegulationDetails />,
        requiredPermission: 'missions_view',
        hidden: true,
      },
      {
        name: 'Modifier dossier de régulation',
        layout: '/admin',
        path: '/dossier-regulation/edit/:id',
        icon: 'missions.png',
        component: <DossierRegulationEdit />,
        requiredPermission: 'missions_view',
        hidden: true,
      },
      {
        name: 'Décision dossier de régulation',
        layout: '/admin',
        path: '/dossier-regulation/decision/:id',
        icon: 'missions.png',
        component: <DossierRegulationDecision />,
        requiredPermission: 'missions_view',
        hidden: true,
      },
      {
        name: 'Missions',
        layout: '/admin',
        path: '/missions',
        icon: 'missions.png',
        component: <Missions />,
        requiredPermission: 'missions_view',
      }, {
        name: 'Détails de la mission',
        layout: '/admin',
        path: '/missions/:id',
        icon: 'missions.png',
        component: <MissionDetails />,
        hidden: true,
      },
      {
        name: 'Créer une mission',
        layout: '/admin',
        path: '/missions/create',
        icon: 'missions.png',
        component: <MissionCreate />,
        hidden: true,
      },
      {
        name: 'Modifier une mission',
        layout: '/admin',
        path: '/missions/edit/:id',
        icon: 'missions.png',
        component: <MissionUpdate />,
        hidden: true,
      },
      {
        name: 'Carte GPS',
        layout: '/admin',
        path: '/carte-gps',
        icon: 'gps.png',
        component: <GpsMap />,
        requiredPermission: 'gps_view',
      }


    ],
  },
  {
    category: true,
    name: 'Analytic',
    items: [
      {
        name: 'Analyses',
        layout: '/admin',
        path: '/analyses',
        icon: 'analyse.png',
        component: <Analyses />,
        requiredPermission: 'analyses_view',
      },
      {
        name: 'Avis',
        layout: '/admin',
        path: '/avis',
        icon: 'avis.png',
        requiredPermission: 'avis_view',
        component: (
          <PermissionWrapper requiredPermission="avis_view">
            <Avis />
          </PermissionWrapper>
        ),
      },
      {
        name: 'Réclamations',
        layout: '/admin',
        path: '/reclamations',
        icon: 'reclamation-dassurance.png',
        requiredPermission: 'reclamations_view',
        component: (
          <PermissionWrapper requiredPermission="reclamations_view">
            <Reclamations />
          </PermissionWrapper>
        ),
      },
      {
        name: 'Logs d\'Audit',
        layout: '/admin',
        path: '/logs',
        icon: 'analyse.png', // You can change this icon
        component: <Logs />,
        requiredPermission: 'logs_view',
      }


    ],
  },
  {
    category: true,
    name: 'Gestion des Clients',
    items: [
      {
        name: 'Patients',
        layout: '/admin',
        path: '/patients',
        icon: 'ptients.png',
        component: <Patients />,
        requiredPermission: 'patients_view',
      }


    ],
  },
  {
    category: true,
    name: 'Gestion des Ressources',
    items: [
      {
        name: 'Staff et Permissions',
        layout: '/admin',
        path: '/utilisateurs',
        icon: 'staff.png',
        component: <Utilisateurs />,
        requiredPermission: 'utilisateurs_view',
      },
      {
        name: 'Pointage de suivi',
        layout: '/admin',
        path: '/pointage-suivi',
        icon: 'pointage.png',
        requiredPermission: 'pointage_view',
        component: (
          <PermissionWrapper requiredPermission="pointage_view">
            <PointageSuivi />
          </PermissionWrapper>
        ),
      }
      ,
      {
        name: 'Ambulances',
        layout: '/admin',
        path: '/vehicules',
        icon: 'vehicule.png',
        component: <Vehicules />,
        requiredPermission: 'vehicules_view',
      },
      {
        name: 'Gestion Stock',
        layout: '/admin',
        path: '/gestion-stock',
        icon: 'stock.png',
        component: <GestionStock />,
        requiredPermission: 'stock_view',
      },
      // {
      //   name: 'Materiels',
      //   layout: '/admin',
      //   path: '/materiels',
      //   icon: 'materiels.png',
      //   component: <Materiels />,
      // },
      {
        name: 'Détails du véhicule',
        layout: '/admin',
        path: '/vehicules/:id',
        icon: 'vehicule.png',
        component: <VehicleDetails />,
        hidden: true,
      },



    ],
  },


  {
    category: true,
    name: 'Gestion des Ressources',
    items: [

      {
        name: 'Paramètres',
        layout: '/admin',
        path: '/profile',
        icon: 'profile.png',
        component: <Profile />,
        requiredPermission: 'profile_view',
      },
      {
        name: 'Documentation',
        layout: '/admin',
        path: '/documentation',
        icon: 'role.png',
        component: <Documentation />,
      }
    ]
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
  {
    name: 'Forgot Password',
    layout: '/auth',
    path: '/forgot-password',
    component: <ForgotPassword />,
  },
];

export default routes;

